export default "__VITE_ASSET__9fbf38bd__"